import { z } from "zod";

/** Search da lista de contatos. Valor inválido na URL vira undefined em vez de quebrar a rota. type "none" = Sem tipo (DAD11). */
export const contactsSearch = z.object({
  q: z.string().trim().max(100).optional().catch(undefined),
  type: z.string().max(40).optional().catch(undefined),
  status: z.enum(["active", "inactive", "no_movement"]).optional().catch(undefined),
});
export type ContactsSearch = z.output<typeof contactsSearch>;
